var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonWingRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 82,
    viewBox: "0 0 49 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.756 24.1188C20.2283 23.7152 19.6075 23.4255 18.9246 23.1979C18.7176 23.1254 18.5003 23.0634 18.2831 22.9909C18.0865 22.6391 17.8899 22.2977 17.6933 21.9562C15.1272 17.476 12.0956 13.1199 8.59831 9.21914C8.60866 8.89838 8.61901 8.56728 8.62935 8.22583C8.70178 5.82534 8.54658 2.19355 7.43945 0C9.3226 0.962267 12.1991 0.651858 14.6409 2.028C17.2691 3.51797 22.1632 7.83265 22.9599 10.7919C23.9842 14.5996 21.2113 18.8625 20.6422 20.7353C20.5387 21.0871 20.5387 23.3013 20.7663 24.1084L20.756 24.1188Z",
    fill: "url(#paint0_linear_318_3180)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.797 7.27344C20.7039 8.97034 20.0624 11.019 18.531 12.9022C19.1518 11.4019 19.5554 9.63254 18.6759 8.03911C18.5414 9.87052 17.5688 11.1949 16.2754 12.9643C16.3168 14.5784 16.1823 15.8407 16.5858 17.3824C19.5036 14.8785 21.4696 13.5127 22.4939 9.66358C22.0904 8.89791 21.4903 8.0805 20.797 7.27344Z",
    fill: "url(#paint1_linear_318_3180)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3068 17.2045C15.9757 15.1558 16.2033 13.045 15.9757 10.9756C15.3445 5.28476 10.616 2.0772 7.43945 0.0078125C8.54658 2.20137 8.70178 5.8435 8.62935 8.23364C8.62935 8.57509 8.60866 8.90619 8.59831 9.22695C12.0956 13.1174 15.1272 17.4838 17.6933 21.9641C17.8899 22.3055 18.0865 22.6573 18.2831 22.9987C18.5107 23.0712 18.728 23.1333 18.9246 23.2057C19.6075 23.4333 20.2283 23.7127 20.756 24.1266C18.5728 22.0261 16.8138 20.2982 16.3068 17.2148V17.2045Z",
    fill: "url(#paint2_linear_318_3180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.663 17.6419C19.3696 18.8525 17.7038 19.3181 16.0586 19.2353C16.6277 20.1355 17.1657 21.0564 17.6934 21.9669C17.89 22.3084 18.0866 22.6602 18.2832 23.0016C18.5108 23.0741 18.7281 23.1361 18.9247 23.2086C19.6076 23.4362 20.2284 23.7156 20.7561 24.1294C20.5285 23.3224 20.5285 21.1185 20.6319 20.7563C21.1079 19.1733 23.1566 15.8933 23.1773 12.6133C22.9186 14.5068 22.3702 16.0278 20.663 17.6419Z",
    fill: "#5795CC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65005 6.70229C8.80525 5.42962 8.88803 3.76376 9.51919 2.72906C10.4918 1.12528 13.2027 1.87026 14.5478 2.47039C16.0688 3.15329 17.3622 4.1259 18.6762 5.09852C17.2484 3.78445 15.7481 2.66698 14.6409 2.03582C12.1991 0.649324 9.3226 0.959732 7.43945 0.0078125C8.32929 1.7668 8.60866 4.46735 8.6397 6.70229H8.65005Z",
    fill: "url(#paint3_linear_318_3180)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43945 0.0078125C12.5922 3.16363 15.5308 6.41258 16.3275 10.9135C17.5277 8.11983 17.6622 6.82646 16.6482 3.66029L17.1552 4.78811C17.9933 7.14721 17.445 9.09244 16.5758 11.255C16.4827 11.4826 16.4827 11.8551 16.5241 12.6208C16.6379 14.6384 16.6172 15.9732 16.6586 16.9872C19.4212 15.0419 20.9008 13.583 22.3184 10.3444C21.3458 13.4692 19.6282 15.2075 17.1759 17.0389C16.8345 17.2976 16.6793 17.6804 16.731 18.1046C16.731 18.1667 16.7517 18.2288 16.7621 18.2909C17.0207 19.8636 17.9623 21.2087 20.756 24.1162C18.5314 22.4193 17.1759 20.8466 16.5137 19.4394C16.3896 19.16 16.1516 18.9841 15.8619 18.922C15.7791 18.7875 15.6963 18.653 15.6135 18.5289C15.7998 18.5599 15.9964 18.5806 16.2033 18.6013C15.9033 17.5149 15.986 16.3353 16.0274 14.9074C12.7681 13.9555 11.1023 12.062 9.70544 8.98897C9.26052 8.00601 9.12601 7.55074 8.90872 6.5057C9.20878 7.39554 9.43642 8.05774 9.86064 8.91654C11.2989 11.824 12.8923 13.6554 16.0378 14.5349C16.0688 13.2519 16.0481 11.7723 15.6963 9.99263C14.7237 5.04678 10.647 2.29449 7.43945 0.0181595V0.0078125Z",
    fill: "url(#paint4_linear_318_3180)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.406 39.9938C31.5996 38.7625 33.5966 36.8794 34.7037 34.5513C36.8352 30.0814 37.963 26.0357 37.8699 22.0729C36.9697 23.3145 36.0384 24.225 34.6106 25.239C35.8005 23.9353 37.0525 21.8556 37.7457 20.2725C37.7354 20.1483 37.7147 20.0242 37.694 19.8897C36.9593 14.6437 33.2137 6.37653 32.6343 2.35156C30.089 5.52808 26.602 8.38384 23.3427 11.4983C22.8564 11.9535 22.3805 12.4295 21.8942 12.9158C22.0701 13.6711 22.3184 14.4989 22.4736 15.1921C22.6495 15.9682 22.1114 15.9268 21.6044 15.5025C21.1906 15.1611 20.8284 14.6851 20.6008 14.2506C19.0384 15.9061 17.5277 17.6754 16.2344 19.5172C16.7414 20.3346 17.2277 21.152 17.6933 21.9694C20.7043 27.2153 23.4359 33.1027 25.0603 38.9384L25.1431 39.2385L25.0603 39.5385C24.8948 40.1386 24.7085 40.7388 24.5223 41.3492C26.3227 41.1009 28.0816 40.7491 29.406 40.0041V39.9938Z",
    fill: "url(#paint5_linear_318_3180)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7322 29.6882C29.8296 20.6243 30.9678 12.0363 32.6336 2.35156C33.213 6.37653 36.9586 14.6541 37.6933 19.8897C37.714 20.0138 37.7243 20.138 37.745 20.2725C37.0518 21.8556 35.8101 23.9353 34.6099 25.239C36.0378 24.225 36.9793 23.3145 37.8692 22.0729C37.9623 26.0357 36.8345 30.0814 34.703 34.5513C33.5959 36.869 31.5989 38.7625 29.4054 39.9938C28.081 40.7388 26.3116 41.0906 24.5216 41.3389C24.7079 40.7388 24.8941 40.1283 25.0596 39.5282L25.1424 39.2281L25.0596 38.9281C24.6147 37.3139 24.0767 35.6895 23.4766 34.0857C24.2629 32.7302 25.0079 31.292 25.7322 29.6882Z",
    fill: "url(#paint6_linear_318_3180)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4342 11.0301C33.4616 8.7331 32.2303 6.66371 30.968 6.58093C29.2711 6.46712 26.198 8.97108 23.9941 10.8853C27.0568 8.01916 30.254 5.32895 32.6338 2.35938C33.2133 6.38434 36.9589 14.6619 37.6935 19.8975C37.7142 20.0216 37.7246 20.1458 37.7452 20.2803C37.6418 20.5286 37.5176 20.7873 37.3831 21.0563C36.8658 17.6211 35.8 14.2377 34.4446 11.0301H34.4342ZM37.8694 22.0703C37.8901 23.0533 37.8384 24.0259 37.7246 25.0192C37.7039 24.1708 37.6521 23.3223 37.559 22.4739C37.6625 22.3393 37.7659 22.2048 37.8694 22.06V22.0703Z",
    fill: "url(#paint7_linear_318_3180)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0185 24.0169C24.9972 20.2816 23.2175 17.1051 22.2656 12.5421C22.6278 12.18 22.9899 11.8282 23.3521 11.4867C23.9832 10.8866 24.6247 10.2968 25.2559 9.70703C24.7489 14.3839 27.346 19.9298 28.7635 21.5957C28.5359 22.4131 28.2876 23.2202 28.0185 24.0169Z",
    fill: "url(#paint8_linear_318_3180)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1108 15.8633C21.1906 19.8262 24.8741 23.4786 27.5229 25.3721C26.6331 27.7002 25.5674 29.9558 24.4085 32.1908C23.3841 31.5389 22.4529 30.6387 21.6148 29.5937C20.4249 26.9552 19.0902 24.3892 17.6933 21.9576L17.5898 21.7817C17.2381 20.747 16.9483 19.7434 16.7207 18.8122C17.4657 17.7982 18.2727 16.8152 19.1108 15.8633Z",
    fill: "url(#paint9_linear_318_3180)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.036 35.6342C28.6818 36.7724 34.3415 34.3615 37.4767 26.591C36.98 29.1363 36.0385 31.7541 34.714 34.5374C33.6069 36.8552 31.61 38.7487 29.4164 39.9799C28.092 40.7249 26.3227 41.0767 24.5326 41.325C24.7189 40.7249 24.9051 40.1145 25.0707 39.5143L25.1535 39.2143L25.0707 38.9142C24.7603 37.8174 24.4188 36.7207 24.0463 35.6239L24.036 35.6342ZM16.2344 19.5033C17.1863 18.1375 18.2624 16.8235 19.3902 15.5508C18.2313 17.5374 17.4346 18.9446 16.9794 20.7346C16.731 20.3207 16.4827 19.9172 16.2344 19.5033Z",
    fill: "url(#paint10_linear_318_3180)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6344 2.35156C31.4963 8.88049 30.4098 14.8817 28.537 20.9037C26.4366 17.2512 25.4743 15.2128 25.1846 10.7636C24.8535 15.2232 26.3021 17.9755 28.268 21.7625C27.2023 25.0631 25.8882 28.3742 24.181 31.7887C23.2083 31.2506 22.2461 30.2573 21.3562 29.0364C21.7184 29.8227 22.0702 30.6091 22.4013 31.4058C22.8565 31.8714 23.3325 32.2543 23.7981 32.5233C23.6222 32.8544 23.4463 33.1958 23.2497 33.5269C23.3739 33.8477 23.4877 34.1685 23.6119 34.4892C23.974 33.8787 24.3155 33.2683 24.6569 32.6578C25.3088 31.4989 25.8985 30.3401 26.4262 29.1812C26.5918 28.8294 26.8919 28.5914 27.285 28.519C31.1858 27.7637 34.8901 25.8909 37.1767 22.9834C34.2382 25.6219 31.041 27.2463 27.0367 27.8154C28.237 24.9907 29.1164 22.1763 29.8097 19.3309C29.9339 18.8032 30.1822 18.3893 30.5754 18.0169C32.4689 16.2372 33.7519 14.861 34.7969 12.3571C33.0793 14.8403 32.3757 15.7095 30.2132 17.603C31.2686 12.7606 31.8687 7.76302 32.6344 2.36191V2.35156ZM17.5899 21.7831C17.3106 21.0175 17.0829 20.3139 16.9277 19.7241C16.9588 20.0966 17.0209 20.5105 17.114 20.9761C17.2795 21.2451 17.4347 21.5245 17.5899 21.7935V21.7831ZM24.1085 35.8654C27.9576 36.0413 31.817 35.2652 34.8073 33.051C31.6411 34.8203 27.9679 35.6274 23.9223 35.3066C23.9844 35.4929 24.0464 35.6791 24.1189 35.8654H24.1085Z",
    fill: "url(#paint11_linear_318_3180)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.168 60.583C17.9513 60.7693 23.073 63.6561 25.6391 63.6768C32.3646 63.7285 38.1382 59.3931 42.277 54.4059C40.6732 55.1095 39.0074 55.0267 37.3001 54.737C39.4109 54.3645 42.7943 52.947 44.4706 51.2397C46.9124 46.9457 48.4645 41.2135 48.4024 36.6919C48.3507 33.0187 47.823 29.2938 48.1644 25.9414C46.5917 28.4661 44.9775 29.9457 42.8357 31.0321C41.5424 32.3255 40.9319 33.2981 39.8041 35.0364C39.6696 33.8154 39.773 33.0394 39.98 32.1806C37.6416 32.9463 34.7237 33.5982 30.916 34.5811C28.7535 35.1399 26.5393 35.5641 24.3975 36.2159C24.6768 37.054 24.9355 37.8921 25.1631 38.7406L25.2459 39.0407L25.1631 39.3407C23.4559 45.4661 20.5173 51.695 17.2994 57.1685C16.6165 58.317 15.9129 59.4655 15.168 60.6037V60.583Z",
    fill: "url(#paint12_linear_318_3180)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1754 54.6012C38.0263 59.5884 32.263 63.9238 25.5375 63.8721C22.9715 63.8514 17.8497 60.9646 15.0664 60.7783C15.3872 60.292 15.6976 59.8057 15.9976 59.3194C21.3987 54.2701 29.5521 53.8562 37.271 46.3133C43.0756 40.6432 47.0282 33.1209 48.0629 26.1367C47.7317 29.4891 48.2594 33.214 48.3008 36.8872C48.3629 41.4088 46.8109 47.141 44.369 51.435C42.6928 53.1423 39.3093 54.5598 37.1985 54.9323C38.9058 55.2117 40.5613 55.3048 42.1754 54.6012Z",
    fill: "url(#paint13_linear_318_3180)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8644 56.9274C27.162 61.1179 35.3464 59.7107 40.1474 56.8446C36.2259 60.8178 31.2284 63.9116 25.5375 63.8702C22.9715 63.8495 17.8497 60.9627 15.0664 60.7764C15.8114 59.6486 16.515 58.5001 17.1979 57.3412C17.8497 56.2445 18.4809 55.1166 19.1017 53.9578C19.795 55.0028 20.7158 56.0065 21.8747 56.917L21.8644 56.9274ZM24.2959 36.4093C24.9064 36.2231 25.5272 36.0575 26.148 35.9023C25.5479 36.161 24.9684 36.4611 24.4201 36.7818C24.3787 36.6577 24.3373 36.5335 24.2959 36.4093Z",
    fill: "url(#paint14_linear_318_3180)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6859 42.9109C27.1722 40.5311 29.0243 37.0649 31.4041 34.623C32.0766 34.4471 32.7285 34.2919 33.339 34.1367C31.6731 35.9267 30.8454 37.7375 29.9866 40.2104C28.4035 44.7734 29.1174 47.3912 29.7693 52.068C28.8691 52.5543 27.9896 52.9785 27.1308 53.3924C26.1996 49.564 26.0444 45.9943 26.6755 42.9213L26.6859 42.9109Z",
    fill: "url(#paint15_linear_318_3180)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7119 45.1636C44.3157 42.8252 46.4161 39.2865 47.1404 36.5756C47.4818 35.303 47.9888 32.1678 46.8507 31.1124C46.4989 30.7813 45.9712 30.6468 45.2366 30.8538C43.312 31.3711 41.4082 33.3474 40.0527 34.6925C40.9633 33.2853 41.5737 32.3851 42.7222 31.247C44.8641 30.1709 46.4885 28.6913 48.0509 26.1562C47.7198 29.5087 48.2475 33.2336 48.2889 36.9067C48.2889 37.0102 48.2889 37.1033 48.2889 37.2068C47.3784 40.4557 45.6711 42.132 42.6912 45.174L42.7119 45.1636Z",
    fill: "url(#paint16_linear_318_3180)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9806 53.9106C24.8838 54.3555 23.8284 54.8108 22.742 55.2867C22.5143 54.2727 21.8521 51.0445 21.8418 48.3336C22.504 46.8436 23.1145 45.3226 23.6732 43.8016C23.6939 43.7706 23.7249 43.7395 23.7456 43.7085C24.4389 42.7773 24.801 41.7219 25.6495 40.832C24.4285 45.1984 24.7079 48.9544 25.9806 53.9106Z",
    fill: "url(#paint17_linear_318_3180)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0629 26.1445C46.9144 32.5596 43.7069 39.2645 38.0988 45.0795C37.2814 40.1233 39.0404 35.7569 41.9893 31.9802C38.6472 35.9121 36.6709 40.413 37.5401 45.6485C36.0294 47.1592 34.3532 48.6078 32.5011 49.9632C31.6733 50.5633 30.8249 51.1117 29.9247 51.6291C28.8279 43.9103 29.8316 39.668 32.946 34.4531C30.5662 37.2572 29.3349 40.413 28.8072 43.3412C28.4451 45.3278 29.1383 48.5043 29.3246 51.9602C27.131 53.1604 24.7098 54.1744 22.03 55.2816C21.8748 55.3436 21.7196 55.4161 21.5644 55.4885C21.2436 53.7709 20.9435 52.1775 20.7573 50.6668C20.6435 50.9048 20.5297 51.1324 20.4158 51.3601C20.6124 52.819 20.8297 54.3193 20.9539 55.7679C19.1225 56.6887 17.3635 57.9511 16.1219 59.0789C15.9667 59.3272 15.8115 59.5652 15.6562 59.8135C16.96 58.6961 18.1395 57.9407 19.4536 57.2578C22.7853 57.8786 25.2272 59.4617 27.9898 59.9273C31.1663 60.4654 34.5188 59.886 38.285 57.8062C30.3179 60.9724 27.4 58.9237 20.0951 56.9371C20.809 56.5853 21.5747 56.2335 22.4128 55.8506C23.6441 55.2919 24.8961 54.7746 26.1584 54.2469C28.0416 53.4605 28.352 53.4915 29.2211 53.4915C32.1803 53.4708 34.8809 53.4501 37.3745 52.9121C38.9783 52.5707 42.3617 50.4702 45.321 48.2042C39.4129 52.105 36.1846 52.9328 29.3142 52.8604C30.5455 52.2706 31.7561 51.6084 32.9357 50.8117C40.1268 45.9796 47.2662 35.2499 48.0422 26.1445H48.0629ZM24.5236 37.133C24.5236 37.133 24.6064 37.0399 24.6478 36.9881L24.5132 37.1123V37.133H24.5236Z",
    fill: "url(#paint18_linear_318_3180)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8412 59.5664C16.9897 59.9699 18.1796 60.4666 19.4005 61.0253C23.8187 63.0326 30.5546 68.4234 35.6246 66.5609C32.1583 69.4271 31.2995 71.9621 28.4438 74.2177C27.1711 75.2214 25.5156 76.3388 23.6635 77.4046C22.2356 78.2323 20.7663 78.5117 19.1315 78.2737C18.4693 78.1806 17.7864 78.0254 17.0207 77.8288C17.3312 78.0668 18.3865 78.5117 18.6866 78.6669C18.9039 78.7807 18.9453 79.0911 19.1315 79.236C19.2867 79.3498 19.4523 79.4326 19.6282 79.4946C15.7481 81.2536 11.6196 82.4228 8.53624 81.8537C4.81134 81.1605 2.15217 79.4222 0 77.001C0.13451 76.8976 0.279368 76.8044 0.413878 76.701C6.60136 72.1793 11.7334 66.0746 15.8308 59.5768L15.8412 59.5664Z",
    fill: "url(#paint19_linear_318_3180)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3756 73.4005C26.9026 73.7626 24.7194 73.7523 21.3463 73.3591C25.0919 72.9245 28.4236 72.1381 31.476 71.0207C32.5831 69.6238 33.7006 68.1339 35.6251 66.5508C28.3616 69.7066 21.3463 71.6829 13.5137 72.8107C17.7042 76.2355 20.0219 76.9805 24.9264 76.6494C25.661 76.1941 26.3542 75.7389 26.9958 75.2836C26.2922 75.2215 25.6196 75.0663 24.9574 74.8697C26.2197 74.7766 27.1199 74.6318 28.2167 74.3938C28.2995 74.3317 28.3719 74.2696 28.4443 74.2075C28.7858 73.9385 29.0962 73.6695 29.3859 73.4005H29.3756Z",
    fill: "url(#paint20_linear_318_3180)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6616 72.8519C18.8631 72.8416 32.7073 68.0406 35.6148 66.5609C30.5448 68.4234 23.8089 63.0326 19.3908 61.0253C18.1698 60.4666 16.9903 59.9699 15.8314 59.5664C12.955 64.1191 9.58186 68.4751 5.69141 72.2414C7.67802 72.6036 9.65429 72.8622 11.6616 72.8622V72.8519Z",
    fill: "url(#paint21_linear_318_3180)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.646 59.8768C16.0598 59.8872 16.4737 59.9182 16.8876 59.9596C16.5358 59.8251 16.184 59.6906 15.8426 59.5664L15.646 59.8768ZM0.0117188 76.9907C2.16389 79.4119 4.81271 81.1502 8.54796 81.8434C10.607 82.2262 13.1213 81.8331 15.7287 81.0053C13.0282 81.295 11.0105 81.1915 8.32032 80.1879C5.56803 79.1635 3.55038 77.3218 2.50534 75.0868C1.82244 75.6456 1.12919 76.1836 0.425597 76.701C0.291087 76.8044 0.146229 76.8976 0.0117188 77.001L0.0117188 76.9907Z",
    fill: "url(#paint22_linear_318_3180)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6154 66.5614C31.6319 69.024 20.064 72.4385 14.2179 73.1111C18.1187 76.0496 19.0707 76.4221 24.2648 76.7221C19.5777 77.0429 17.6324 76.2979 14.2697 73.9699C12.7073 72.8938 13.5971 73.2766 11.6829 73.2456C9.9136 73.2249 7.96838 72.9869 6.00245 72.6454C9.52042 77.1153 12.6969 78.8122 17.6635 79.9401C12.7901 79.4744 9.51007 77.105 6.08523 73.7629C5.661 73.349 5.42302 73.0179 5.14366 72.78C5.43337 72.5109 5.72309 72.2316 6.00245 71.9522C6.47841 72.0246 6.77848 71.9625 7.18201 71.4245C9.5825 68.2376 12.2624 66.2096 16.1632 65.0508C11.6622 66.758 9.9136 68.5791 7.50276 72.1902C10.2447 72.5523 13.0694 72.4282 15.8114 72.0764C19.2673 68.5481 21.3884 65.982 26.5722 65.3405C21.1504 66.9029 20.2295 68.1342 16.6598 71.9625C23.5612 70.9692 30.7627 68.486 35.6258 66.5614H35.6154ZM3.55022 74.1975C5.19539 76.0082 7.54415 78.1707 9.92395 79.4434C7.14062 78.1086 5.08157 76.4945 3.17773 74.5182C3.3019 74.4148 3.42606 74.301 3.55022 74.1975Z",
    fill: "url(#paint23_linear_318_3180)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_3180",
    x1: 23.1875,
    y1: 12.0646,
    x2: 7.4498,
    y2: 12.0646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6179AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#90A8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#A1BCE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B1D0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B7D8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_3180",
    x1: 22.4939,
    y1: 12.3228,
    x2: 16.2754,
    y2: 12.3228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_3180",
    x1: 20.7663,
    y1: 12.062,
    x2: 7.4498,
    y2: 12.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E96B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_3180",
    x1: 18.6762,
    y1: 3.34988,
    x2: 7.4498,
    y2: 3.34988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_3180",
    x1: 22.3287,
    y1: 12.062,
    x2: 7.4498,
    y2: 12.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_3180",
    x1: 27.0573,
    y1: 41.3389,
    x2: 27.0573,
    y2: 2.35156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6179AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#90A8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#A1BCE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B1D0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B7D8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_318_3180",
    x1: 37.8795,
    y1: 21.8452,
    x2: 23.4766,
    y2: 21.8452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_318_3180",
    x1: 30.9473,
    y1: 25.0192,
    x2: 30.9473,
    y2: 2.34903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_3180",
    x1: 28.7635,
    y1: 16.8671,
    x2: 22.2656,
    y2: 16.8671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_3180",
    x1: 27.5333,
    y1: 24.0374,
    x2: 16.731,
    y2: 24.0374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_3180",
    x1: 26.8607,
    y1: 41.3354,
    x2: 26.8607,
    y2: 15.5611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#887BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_3180",
    x1: 37.1871,
    y1: 19.124,
    x2: 16.9277,
    y2: 19.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_318_3180",
    x1: 48.4231,
    y1: 44.8143,
    x2: 15.168,
    y2: 44.8143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_318_3180",
    x1: 48.3112,
    y1: 45.0096,
    x2: 15.0664,
    y2: 45.0096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_318_3180",
    x1: 40.1474,
    y1: 49.8811,
    x2: 15.0664,
    y2: 49.8811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_318_3180",
    x1: 29.8314,
    y1: 53.3821,
    x2: 29.8314,
    y2: 34.1367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_318_3180",
    x1: 44.1915,
    y1: 45.1636,
    x2: 44.1915,
    y2: 26.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_318_3180",
    x1: 23.9215,
    y1: 55.2971,
    x2: 23.9215,
    y2: 40.8424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_318_3180",
    x1: 48.0733,
    y1: 43.1446,
    x2: 15.6769,
    y2: 43.1446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_318_3180",
    x1: 35.6246,
    y1: 70.7722,
    x2: 0.0103464,
    y2: 70.7722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90A8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#586B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_318_3180",
    x1: 35.6251,
    y1: 71.6415,
    x2: 13.5033,
    y2: 71.6415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_318_3180",
    x1: 35.6252,
    y1: 66.2092,
    x2: 5.70175,
    y2: 66.2092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#B2D7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#819DC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5D729F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#47588A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_318_3180",
    x1: 16.898,
    y1: 70.7722,
    x2: 0.0117188,
    y2: 70.7722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_318_3180",
    x1: 35.6258,
    y1: 72.4902,
    x2: 3.17773,
    y2: 72.4902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonWingRight);
export default __webpack_public_path__ + "static/media/button-wing-right.a9a44b4d7c62fa3f933775f1c9576d96.svg";
export { ForwardRef as ReactComponent };